import { type FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import { HubspotMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'

import HubspotTestimonialBackground from './assets/HubspotTestimonialBackground.svg'
import scottBrinkerAvatar from './assets/ScottBrinker.png'

const testimonialData = {
  text: `“The new wave of advancements happening in AI today holds the promise of finally delivering on the ideal: a generative AI engine that is able to absorb everything we know about a particular prospect or customer, along with all the relevant content and information for a specific marketing campaign or program, and to synthesize a personalized message — an email, a web page, a mobile experience, a contact center engagement, etc. — that is wholly crafted for that specific person.”`,
  name: `Scott Brinker`,
  position: `VP of Platform, Hubspot`,
}
const HubspotTestimonial: FC = () => {
  const theme = useTheme()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <StyledTestimonial>
          <Testimonial.Base height="auto" tokens={{ background: theme.palette.neutrals.white[100] }}>
            <Testimonial.BaseContentSlot>
              <Testimonial.BaseLogo>
                <HubspotMonoLogo color={theme.palette.twilio.gray[100]} />
              </Testimonial.BaseLogo>
              <Testimonial.BaseText tokens={{ color: theme.palette.twilio.gray[100] }}>
                {testimonialData.text}
              </Testimonial.BaseText>
            </Testimonial.BaseContentSlot>
            <Testimonial.BaseAuthorSlot>
              <Testimonial.AuthorAvatar width={60} height={60} alt="" src={scottBrinkerAvatar} />
              <Testimonial.AuthorInfo>
                <Testimonial.AuthorName tokens={{ color: theme.palette.twilio.gray[100] }}>
                  {testimonialData.name}
                </Testimonial.AuthorName>
                <Testimonial.AuthorPosition tokens={{ color: theme.palette.twilio.gray[100] }}>
                  {testimonialData.position}
                </Testimonial.AuthorPosition>
              </Testimonial.AuthorInfo>
            </Testimonial.BaseAuthorSlot>
          </Testimonial.Base>
        </StyledTestimonial>
      </StyledSection>
      <Background>
        <HubspotTestimonialBackground width="100%" height="100%" />
      </Background>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
  z-index: 0;
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const Background = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  ${({ theme }) => theme.breakpoints.up(`xxxl`)} {
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 30%;
      height: 100%;
    }

    &::before {
      left: 0;
      background: linear-gradient(269.69deg, rgba(18, 28, 45, 0) 0.25%, #121c2d 60%);
    }

    &::after {
      right: 0;
      background: linear-gradient(-269.69deg, rgba(18, 28, 45, 0) 0.25%, #121c2d 60%);
    }
  }
`

const StyledTestimonial = styled(TestimonialBase)`
  max-width: 1040px;
`

export default HubspotTestimonial
